/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from 'lodash';

import type { RecurringTournament } from '@swf/generated/types/api/v0/SwHomeGames';

import {
  TXTINT_Friday,
  TXTINT_Monday,
  TXTINT_Saturday,
  TXTINT_Sunday,
  TXTINT_Thursday,
  TXTINT_Tuesday,
  TXTINT_Wednesday
} from './utils.messages.json';

export enum RecurringDay {
  'HG_RD_SUNDAY',
  'HG_RD_MONDAY',
  'HG_RD_TUESDAY',
  'HG_RD_WEDNESDAY',
  'HG_RD_THURSDAY',
  'HG_RD_FRIDAY',
  'HG_RD_SATURDAY'
}

export enum WhichRecurringDay {
  'HG_WRD_FIRST',
  'HG_WRD_SECOND',
  'HG_WRD_THIRD',
  'HG_WRD_FOURTH',
  'HG_WRD_LAST'
}

export enum MonthlyRepeat {
  OnDay,
  OnThe
}

export enum RangeOption {
  Never,
  On,
  After
}

export const days = [
  {
    name: RecurringDay.HG_RD_SUNDAY,
    translation: TXTINT_Sunday
  },
  {
    name: RecurringDay.HG_RD_MONDAY,
    translation: TXTINT_Monday
  },
  {
    name: RecurringDay.HG_RD_TUESDAY,
    translation: TXTINT_Tuesday
  },
  {
    name: RecurringDay.HG_RD_WEDNESDAY,
    translation: TXTINT_Wednesday
  },
  {
    name: RecurringDay.HG_RD_THURSDAY,
    translation: TXTINT_Thursday
  },
  {
    name: RecurringDay.HG_RD_FRIDAY,
    translation: TXTINT_Friday
  },
  {
    name: RecurringDay.HG_RD_SATURDAY,
    translation: TXTINT_Saturday
  }
];

const getDaily = (values: any) => ({
  numberOfDays: get(values, 'repeatEvery'),
  everyWeekday: false
});

const getWeekly = (values: any) => {
  const recurringDays: RecurringDay[] = get(values, 'recurringDays');

  return {
    recurringDays: recurringDays.map(
      (day) => RecurringDay[day]
    ) as RecurringTournament['recurringDays'],
    numberOfWeeks: get(values, 'repeatEvery')
  };
};

const getMonthly = (values: any) => {
  const repeatEvery = get(values, 'repeatEvery');
  const monthlyRepeat = get(values, 'monthlyRepeat');
  let recurringDay = 'HG_RD_NONE';
  let whichRecurringDay = 'HG_WRD_NONE';
  let dayOfMonth = 0;

  if (monthlyRepeat === MonthlyRepeat.OnDay) {
    dayOfMonth = get(values, 'dayOfMonth');
  } else {
    recurringDay = get(values, 'recurringDay');
    whichRecurringDay = get(values, 'whichRecurringDay');
  }

  return {
    numberMonths: repeatEvery,
    recurringDay,
    whichRecurringDay,
    dayOfMonth
  };
};

const getRange = (values: any) => {
  const occurrenceRange = get(values, 'occurrenceRange');
  const nbOccurences = get(values, 'nbOccurences');
  const endDate = new Date(get(values, 'endDate'));
  const date = typeof endDate === 'object' ? endDate : new Date(endDate);
  const dateObj =
    occurrenceRange === RangeOption.On
      ? {
          endDate: {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
          }
        }
      : {};

  return {
    ...dateObj,
    nbOccurences: occurrenceRange === RangeOption.After ? nbOccurences : 0
  };
};

export const getRecurringOptions = (values: any) => {
  const recurringPatternType = get(values, 'recurringPatternType');
  let rest;
  const range = getRange(values);

  switch (recurringPatternType) {
    case 'HG_RECURRING_DAILY':
      rest = getDaily(values);
      break;
    case 'HG_RECURRING_WEEKLY':
      rest = getWeekly(values);
      break;
    case 'HG_RECURRING_MONTHLY':
      rest = getMonthly(values);
      break;
    default:
      break;
  }

  return {
    recurringPatternType,
    ...rest,
    ...range
  };
};
